// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucideMonitor as RawLucideMonitor } from "lucide-react";
export const LucideMonitor = /* @__PURE__ */ createIcon(RawLucideMonitor, "LucideMonitor", 2);
